import { TasksApi } from "tasks-experience-client";
import { createCommonConfigurationForApis } from "./CommonHelper";
import { spire360ApiClient } from "./Spire360ApiClient";
import { AxiosInstance } from "axios";

export function createTaskApi(): TasksApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === 'true';
  if(isGatewayEnabled){
    const basePath = process.env.REACT_APP_TASK_API_URL;
  const axiosInstance: AxiosInstance = spire360ApiClient;
  return new TasksApi(

    undefined,
    `${process.env.REACT_APP_TASK_API_URL_GATEWAY}`,
    axiosInstance

    // "http://localhost:4090"
  );

  }
  else{
  return new TasksApi(

    createCommonConfigurationForApis(),
    `${process.env.REACT_APP_TASK_API_URL}`

    // "http://localhost:4090"
  );
  }
  
}
